import React from 'react';
import PropTypes from 'prop-types';
import { Typography, ListItem } from '@sm/wds-react';

export const ColumnTitle = ({ title }) => {
  return (
    <ListItem key={title} className="sm-nav-submenu__list-item">
      <Typography
        variant="body"
        color="dark"
        className="sm-nav-submenu__column-title"
      >
        {title}
      </Typography>
    </ListItem>
  );
};

export default ColumnTitle;

ColumnTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
